import { ChangeEvent, useState } from 'react';
import { FiSearch } from 'react-icons/fi';

import Loading from '@components/Loading';

import { Container } from './styles';

interface Props {
  value: string;
  loading: boolean;
  placeholder?: string;
  handleSearch: () => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const Search: React.FC<Props> = ({
  value,
  loading,
  onChange,
  handleSearch,
  placeholder,
}) => {
  const [hasFocus, setHasFocus] = useState(false);

  return (
    <Container hasFocus={hasFocus} disabled={loading} data-cy="search-input">
      <input
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
        disabled={loading}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        placeholder={placeholder}
      />

      <button
        type="button"
        onClick={handleSearch}
        disabled={!value || loading}
        title="Search"
      >
        {loading ? (
          <Loading className="search-loading" size={25} />
        ) : (
          <FiSearch />
        )}
      </button>
    </Container>
  );
};

export default Search;
